import { render, staticRenderFns } from "./pici.vue?vue&type=template&id=70a705f4&scoped=true"
import script from "./pici.vue?vue&type=script&lang=js"
export * from "./pici.vue?vue&type=script&lang=js"
import style0 from "./pici.vue?vue&type=style&index=0&id=70a705f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a705f4",
  null
  
)

export default component.exports